var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlanF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M76.73 243.29C43.65 227.573 21.6 202.642 9.68 168.396 3.6 150.924 2.656 132.89 4.277 114.98c2.176-24.048 11.367-45.743 26.818-64.643 15.62-19.108 34.93-32.506 58.334-40.594 17.677-6.11 35.844-7.107 53.893-5.437 24.02 2.222 45.697 11.47 64.564 26.995 18.93 15.576 32.225 34.73 40.309 57.954 6.152 17.674 7.111 35.828 5.506 53.874-2.139 24.038-11.402 45.718-26.866 64.617-15.637 19.11-34.967 32.491-58.356 40.562-17.503 6.04-35.448 6.566-53.423 5.466-13.162-.806-25.91-4.73-38.327-10.483z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    d: "M126.037 75.007c-4.657-.811-5.775.844-5.627 5.024.347 9.819.23 19.66.039 29.487-.057 2.928.888 3.554 3.639 3.534 16.828-.119 33.66.087 50.485-.169 3.892-.059 4.639 1.093 4.522 4.692a398.35 398.35 0 0 0 0 25.488c.108 3.399-1.02 4.043-4.16 4.015-16.66-.15-33.326.084-49.984-.184-3.95-.064-4.545 1.183-4.512 4.724.174 18.827-.001 37.657.158 56.484.029 3.428-.794 4.584-4.39 4.505-10.826-.238-21.661-.188-32.49-.022-3.112.048-4.323-.579-4.316-4.057.112-54.652.098-109.305.022-163.957-.003-2.792.706-3.65 3.593-3.642 33.991.1 67.982.1 101.973 0 2.971-.008 4.027.604 3.94 3.811a494.324 494.324 0 0 0-.003 26.489c.084 3.16-.883 3.867-3.906 3.846-19.494-.133-38.99-.068-58.983-.068z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanF);
export default __webpack_public_path__ + "static/media/icon_plan_F.f2c25bf287e774dbbb15b4783b1050c7.svg";
export { ForwardRef as ReactComponent };